import { PolicyActionTypes } from './policy.types'

//Add Policy
export const addPolicyRequest = data => ({
    type: PolicyActionTypes.ADD_POLICY_REQUEST,
    payload: data
})

export const addPolicyRequestSuccess = data => ({
    type: PolicyActionTypes.ADD_POLICY_REQUEST_SUCCESS,
    payload: data
})

export const addPolicyRequestError = data => ({
    type: PolicyActionTypes.ADD_POLICY_REQUEST_ERROR,
    payload: data
})

export const addPolicyRequestStatus = data => ({
    type: PolicyActionTypes.ADD_POLICY_REQUEST_STATUS,
    payload: data
})

//Policy List
export const policyListRequest = data => ({
    type: PolicyActionTypes.POLICY_LIST_REQUEST,
    payload: data
})

export const policyListRequestSuccess = data => ({
    type: PolicyActionTypes.POLICY_LIST_REQUEST_SUCCESS,
    payload: data
})

export const policyListRequestError = data => ({
    type: PolicyActionTypes.POLICY_LIST_REQUEST_ERROR,
    payload: data
})

//Policy Detail
export const policyDetailRequest = data => ({
    type: PolicyActionTypes.POLICY_DETAIL_REQUEST,
    payload: data
})

export const policyDetailRequestSuccess = data => ({
    type: PolicyActionTypes.POLICY_DETAIL_REQUEST_SUCCESS,
    payload: data
})

export const policyDetailRequestError = data => ({
    type: PolicyActionTypes.POLICY_DETAIL_REQUEST_ERROR,
    payload: data
})

//Assign Policy
export const assignPolicyRequest = data => ({
    type: PolicyActionTypes.ASSIGN_POLICY_REQUEST,
    payload: data
})

export const assignPolicyRequestSuccess = data => ({
    type: PolicyActionTypes.ASSIGN_POLICY_REQUEST_SUCCESS,
    payload: data
})

export const assignPolicyRequestError = data => ({
    type: PolicyActionTypes.ASSIGN_POLICY_REQUEST_ERROR,
    payload: data
})

export const assignPolicyRequestStatus = data => ({
    type: PolicyActionTypes.ASSIGN_POLICY_REQUEST_STATUS,
    payload: data
})

//Policy Mark Complete
export const policyMarkCompleteRequest = data => ({
    type: PolicyActionTypes.POLICY_MARK_COMPLETE_REQUEST,
    payload: data
})

export const policyMarkCompleteRequestSuccess = data => ({
    type: PolicyActionTypes.POLICY_MARK_COMPLETE_REQUEST_SUCCESS,
    payload: data
})

export const policyMarkCompleteRequestError = data => ({
    type: PolicyActionTypes.POLICY_MARK_COMPLETE_REQUEST_ERROR,
    payload: data
})

export const policyMarkCompleteRequestStatus = data => ({
    type: PolicyActionTypes.POLICY_MARK_COMPLETE_REQUEST_STATUS,
    payload: data
})